const TestimonialsActionTypes = {};

TestimonialsActionTypes.FETCH_ALL_TESTIMONIALS = 'FETCH_ALL_TESTIMONIALS';
TestimonialsActionTypes.FETCH_TESTIMONIALS = 'FETCH_TESTIMONIALS';
TestimonialsActionTypes.ADD_TESTIMONIALS = 'ADD_TESTIMONIALS';
TestimonialsActionTypes.EDIT_TESTIMONIALS = 'EDIT_TESTIMONIALS';
TestimonialsActionTypes.DELETE_TESTIMONIALS = 'DELETE_TESTIMONIALS';

export default TestimonialsActionTypes;
